import { useEffect } from 'react';

interface IBroadCastProps {
  eventName: string;
  onBroadCast: () => void;
}

const useBroadCast = (props: IBroadCastProps): void => {
  const { eventName, onBroadCast } = props;
  useEffect(() => {
    const handleMessage = (event: any): void => {
      if (event.data === eventName) {
        onBroadCast();
      }
    };
    // Add the event listener
    window.addEventListener('message', handleMessage);
    // Clean up the listener when the component unmounts
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [eventName, onBroadCast]);
};

export default useBroadCast;
